import React from 'react';
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import {
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    TextField
} from "@mui/material";
import {Close, Search} from "@mui/icons-material";
import DialogContent from "@mui/material/DialogContent";
import {flagEmoji} from "../../inc/Utils";
import Box from "@mui/material/Box";

export default class CCountry extends React.Component {

    callback = null;

    constructor(props) {
        super(props);
        this.state = {
            initial_countries: [],
            countries        : [],
            open             : false,
        };
    }

    choose = (countries, callback) => {
        this.callback = callback;
        this.setState({
            initial_countries: countries,
            countries,
            open             : true,
        });
    };

    done = (pair) => {
        this.close();
        this.callback(pair);
    };

    close = () => {
        this.setState({
            open: false,
        });
    };

    filter = (query) => {
        if (query) {
            query = query.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
            this.setState({
                countries: this.state.initial_countries.filter(co => {
                    let line = co.name + '+' + co.code;
                    line = line.normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .toLowerCase();
                    return line.indexOf(query) > -1;
                }),
            });
        } else {
            this.setState({
                countries: this.state.initial_countries,
            });
        }
    };

    render() {
        return (
            <Dialog open={this.state.open}
                    onClose={this.close}
                    scroll="paper"
                    PaperProps={{
                        style: {
                            height      : '100%',
                            margin      : 0,
                            maxHeight   : 'none',
                            borderRadius: 0,
                            width       : 380,
                        },
                    }}>

                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" style={{flexGrow: 1}}>
                            País
                        </Typography>
                        <IconButton
                            onClick={this.close}
                            color="inherit">
                            <Close/>
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent dividers sx={{p: 0}}>

                    <Box className="p-8 border-b-1"
                         style={{
                             background: '#F9f9f9',
                         }}
                         sx={{
                             p: 1,
                         }}>

                        <TextField
                            variant="outlined"
                            size="small"
                            name="query"
                            onChange={e => this.filter(e.target.value)}
                            placeholder="Buscar"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search fontSize="small"/>
                                    </InputAdornment>
                                )
                            }}
                            autoFocus
                            filled/>

                    </Box>

                    <List dense>
                        {this.state.countries.map((o, i) => (
                            <ListItem
                                key={o.id}
                                onClick={() => {
                                    this.done(o);
                                }}
                                divider={i < this.state.countries.length - 1}
                                button
                                dense>

                                <ListItemIcon color="#FF0000" style={{minWidth: 28}}>
                                    <Typography color="textPrimary">
                                        {flagEmoji(o.iso)}
                                    </Typography>
                                </ListItemIcon>

                                <ListItemText primary={o.name}/>

                                <ListItemSecondaryAction>
                                    <Typography color="textSecondary">
                                        +{o.code}
                                    </Typography>
                                </ListItemSecondaryAction>

                            </ListItem>
                        ))}
                    </List>
                </DialogContent>

            </Dialog>
        );
    };
}
